export default __webpack_public_path__ + "img/Poppins-ExtraBold_a62122b.eot";